import React, { Component } from 'react';
import { Button } from 'reactstrap';
import Api from '../Api';
import HtmlHelpers from '../HtmlHelpers';
import SearchIcon from '../Icons/SearchIcon';
export default class TableFilterDropdown extends Component {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    this.getAuth = () => this.props.auth;
    this.getCurrentFilter = () => this.props.currentFilter.value || [];
    this.getTableName = () => this.props.tableName;
    this.getLabelField = () => this.props.labelField;
    this.getValueField = () => this.props.valueField;
    this.getSortOrder = () => this.props.sortOrder || this.getLabelField();
    this.getTitleize = () => this.props.titleize || '';
    this.getDivPosition = () => this.props.widthNum || 'left';
    this.getLeftPosition = () => this.props.leftPosition || '0px';
    this.getWidthNum = () => this.props.widthNum || 250;
    this.getWidth = () => "".concat(this.getWidthNum(), "px");
    this.getOutsideWidth = () => "".concat(this.getWidthNum() + 8, "px");
    this.getApiUrl = () => "list_options".concat(this.getApiParams());
    this.getEnumName = () => this.props.enumName || '';
    this.isEnum = () => this.props.isEnum || false;
    this.getApiParams = () => this.isEnum() ? '?is_enum=Y' + "&enum_name=".concat(this.getEnumName()) + "&label_field=".concat(this.getLabelField()) + "&value_field=".concat(this.getValueField()) : "?table_name=".concat(this.getTableName()) + "&label_field=".concat(this.getLabelField()) + "&value_field=".concat(this.getValueField()) + "&sort_order=".concat(this.getSortOrder()) + "&titleize=".concat(this.getTitleize());
    this.loadOptions = async function () {
      let openFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (openFilter) {
        await _this.setState({
          openFilter: true,
          isChecked: _this.getCurrentFilter()
        });
        _this.fieldRef.setFocus();
      }
      let options = [];
      if (!_this.props.data) {
        await Api.crudList(_this.getAuth(), _this.getApiUrl()).then(response => {
          if (response.data !== undefined) {
            options = response.data.map(d => ({
              label: d.attributes.label,
              lowercaseLabel: (d.attributes[_this.getLabelField()] || '').toLowerCase(),
              value: d.attributes[_this.getValueField()]
            }));
          }
        });
      }
      _this.setState({
        options,
        filteredOptions: options
      });
    };
    this.getStyle = () => ({
      maxHeight: '250px',
      width: this.getWidth(),
      overflow: 'auto',
      padding: '3px',
      marginBottom: '10px',
      border: '2px solid #98CBC1'
    });
    this.getCheckbox = (idx, value) => /*#__PURE__*/React.createElement("input", {
      className: "otto__margin_right",
      type: "checkbox",
      name: "check_".concat(idx),
      checked: this.isChecked(value),
      value: value,
      onChange: event => this.toggleCheck(event)
    });
    this.isChecked = value => (this.state.isChecked || []).includes(value);
    this.toggleCheck = event => {
      const target = event.target;
      this.setState(prevState => {
        let newData = Object.assign([], prevState.isChecked);
        const value = target.value;
        if (target.checked) {
          newData.push(value);
        } else {
          newData = newData.filter(item => item !== value);
        }
        return {
          isChecked: newData
        };
      });
    };
    this.filterField = () => /*#__PURE__*/React.createElement("div", {
      className: "text-left",
      style: {
        width: this.getWidth()
      }
    }, /*#__PURE__*/React.createElement(SearchIcon, null), /*#__PURE__*/React.createElement("input", {
      ref: this.fieldRef.ref,
      type: "text",
      name: "filter",
      className: "icon-field form-control",
      value: this.state.filter,
      onChange: event => this.filterOptions(event)
    }));
    this.filterOptions = event => {
      const value = (event.target.value || '').toLowerCase();
      this.setState(prevState => {
        const filteredOptions = [];
        this.state.options.forEach(option => {
          if (option.lowercaseLabel.includes(value)) {
            filteredOptions.push(option);
          }
        });
        return {
          filteredOptions,
          filter: value
        };
      });
    };
    this.getOptions = () => /*#__PURE__*/React.createElement("div", {
      style: this.getStyle()
    }, this.selectLink(), this.buildOptions());
    this.buildOptions = () => this.state.filteredOptions.length === 0 ? /*#__PURE__*/React.createElement("div", null) : this.state.filteredOptions.map((item, idx) => /*#__PURE__*/React.createElement("div", {
      key: "check_".concat(idx),
      className: "text-left"
    }, /*#__PURE__*/React.createElement("label", null, this.getCheckbox(idx, item.value), item.label)));
    this.getButton = function (type, onClick) {
      let link = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return /*#__PURE__*/React.createElement(Button, {
        className: "btn-sm otto__margin_right",
        color: link ? 'link' : 'info',
        onClick: onClick
      }, type);
    };
    this.submitButtons = () => /*#__PURE__*/React.createElement("div", {
      className: "text-center",
      style: {
        width: this.getWidth(),
        marginBottom: '5px'
      }
    }, this.getButton('Filter', () => this.filterTable(this.state.isChecked)), "\xA0\xA0", this.getButton('Clear Filter', () => {
      this.filterTable([]);
      this.setState({
        isChecked: []
      });
    }), "\xA0\xA0", this.getButton('Cancel', this.closeFilter));
    this.filterTable = filter => {
      this.props.onChange(filter);
      this.setState({
        openFilter: false,
        filter: ''
      });
    };
    this.closeFilter = () => this.setState({
      openFilter: false,
      isChecked: this.getCurrentFilter(),
      filter: ''
    });
    this.selectAll = () => {
      this.setState(prevState => {
        const newData = Object.assign([], prevState.isChecked);
        this.state.filteredOptions.forEach(option => {
          if (newData.indexOf(option.value) === -1) {
            newData.push(option.value);
          }
        });
        this.setState({
          isChecked: newData
        });
      });
    };
    this.unselectAll = () => {
      this.setState(prevState => {
        const newData = Object.assign([], prevState.isChecked);
        this.state.filteredOptions.forEach(option => {
          const idx = newData.indexOf(option.value);
          if (idx !== -1) {
            newData.splice(idx, 1);
          }
        });
        this.setState({
          isChecked: newData
        });
      });
    };
    this.selectLink = () => /*#__PURE__*/React.createElement("div", null, this.getButton('Select All', this.selectAll, true), this.getButton('Clear', this.unselectAll, true));
    this.filterOpenLink = () => {
      const count = this.getCurrentFilter().length;
      const label = count === 0 ? 'Filter' : "".concat(count, " selected");
      return this.getButton(label, this.loadOptions, true);
    };
    this.dropdownStyle = () => ({
      position: 'absolute',
      background: '#FFF',
      border: '4px solid #98CBC1',
      zIndex: 300,
      width: this.getOutsideWidth(),
      overflow: 'auto',
      left: this.getLeftPosition(),
      maxHeight: '340px'
    });
    this.state = {
      options: [],
      filteredOptions: [],
      isChecked: this.getCurrentFilter(),
      filter: ''
    };
    this.fieldRef = HtmlHelpers.utilizeFocus();
  }
  async componentDidMount() {
    const dontPreload = this.props.dontPreload === undefined ? true : this.props.dontPreload;
    if (!dontPreload) {
      this.loadOptions(false);
    }
  }
  render() {
    return this.state.openFilter === true ? /*#__PURE__*/React.createElement("div", {
      className: "text-center",
      style: this.dropdownStyle()
    }, this.filterField(), this.getOptions(), this.submitButtons()) : this.filterOpenLink();
  }
}